export default Object.freeze({
    NONE: 'none',
    ERROR: 'error',
    REMOVE: 'remove',
    REMOVE_AND_ERROR: 'removeAndError'
});
